<template>
  <Card class="course_card">
    <template #content>
      <div class="p-grid px-3">
        <div
          class="p-sm-12 p-md-4 p-lg-4 p-xl-4 d-flex p-ai-center course_card__left"
        >
          <img
            :src="course.gallery_image"
            :alt="course.course_title"
            class="course_card__img"
          />
        </div>
        <div class="p-sm-12 p-md-8 p-lg-8 p-xl-8 px-4 course_card__right">
          <h4 class="course_card__title">
            <b>{{ course.course_title }}</b>
          </h4>
          <p>{{ course.course_description }}</p>
          <p v-if="course.active_sence === 1 && course.level_name">
            <b>Nivel:</b> {{ course.level_name }}
          </p>
          <p v-if="course.active_sence === 2">
            <b>Código:</b> {{ course.course_code }}
          </p>
          <p v-if="course.active_sence === 2 && course.course_cod_sence">
            <b>Código SENCE:</b> {{ course.course_cod_sence }}
          </p>

          <slot></slot>
        </div>
        <div v-if="course.representative" class="p-grid" style="padding-top: 10px">
          <div class="p-col-12" ><b>Tutor administrativo</b></div>
          <div class="p-col-4" style="font-size: 14px; "><b style="font-size: 14px">Nombre:</b> {{ course.representative }}</div>
          <div class="p-col-3" style="font-size: 14px; "><b style="font-size: 14px">Telefono:</b> {{ course.representative_fono }}</div>
          <div class="p-col-5" style="font-size: 14px; "> <b style="font-size: 14px">Correo:</b> {{ course.representative_email }}</div>
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
export default {
  props: {
    course: {
      type: Object,
      required: true
    }
  }
};
</script>

<style>
.course_card {
  /* background-color: #f2f2f2; */
  cursor: pointer;
}
.course_card__left {
  border: 1px solid #000;
  background-color: #fff;
}
.course_card__right p {
  margin: 0.2rem 0;
  font-size: 1.2rem;
}
.course_card__img {
  max-width: 100%;
  min-width: 100%;
}
.course_card__title {
  font-size: 1.5rem;
  color: #fd6b25;
  margin-bottom: 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Curso/CourseCard.vue